var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _polygon, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 394 426.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#812990;}.cls-3{fill:#6b7b84;}.cls-4{fill:url(#linear-gradient);}.cls-5,.cls-6{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{stroke:#ffcb05;}.cls-6{stroke:#6b7b84;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 214.87,
    y1: 389.53,
    x2: 300.77,
    y2: 389.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#812990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.14,424.57l.29-.34a2.23,2.23,0,0,0,1.67.77c1.09,0,1.4-.61,1.4-1.06,0-1.57-3.19-.75-3.19-2.62,0-.87.78-1.42,1.75-1.42a2.27,2.27,0,0,1,1.8.75l-.3.34a1.89,1.89,0,0,0-1.53-.67c-.71,0-1.25.4-1.25,1,0,1.37,3.2.62,3.2,2.61,0,.68-.45,1.51-1.89,1.51A2.47,2.47,0,0,1,311.14,424.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316,420.53a.33.33,0,0,1,.32-.31.32.32,0,1,1,0,.63A.33.33,0,0,1,316,420.53Zm.12,4.79v-3.86h.41v3.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.58,425.32V425l2.28-3.15h-2.28v-.37h2.82v.34L318.09,425h2.34v.37Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.31,423.39a1.92,1.92,0,0,1,1.86-2,1.85,1.85,0,0,1,1.82,2.05v.11h-3.23a1.51,1.51,0,0,0,1.51,1.54,1.72,1.72,0,0,0,1.27-.54l.21.27a2,2,0,0,1-1.51.63A1.9,1.9,0,0,1,321.31,423.39Zm1.85-1.67a1.45,1.45,0,0,0-1.4,1.47h2.81A1.42,1.42,0,0,0,323.16,421.72Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.94,421.76a.36.36,0,0,1,.36-.36.36.36,0,0,1,.35.36.35.35,0,0,1-.35.34A.36.36,0,0,1,325.94,421.76Zm0,3.28a.36.36,0,0,1,.36-.34.35.35,0,1,1,0,.69A.36.36,0,0,1,325.94,425Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.75,425.32l-.53-1.31H330.4l-.53,1.31h-.52l2.18-5.33h.57l2.18,5.33Zm-1.93-4.84-1.27,3.11h2.52Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.21,425.32v-1.45h-2.53v-.41l2.37-3.47h.61v3.46h.79v.42h-.79v1.45Zm0-4.88-2.06,3h2.06Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.23,426.91a6.37,6.37,0,0,1,0-7.07l.25.18a7.08,7.08,0,0,0-.85,3.36,7,7,0,0,0,.85,3.34Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.06,425.32V425c1.82-1.47,3-2.51,3-3.54a1.1,1.1,0,0,0-1.21-1.09,1.73,1.73,0,0,0-1.46.7l-.32-.29a2.18,2.18,0,0,1,1.78-.82,1.54,1.54,0,0,1,1.68,1.5c0,1.18-1.24,2.25-2.78,3.5h2.8v.41Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.62,425.32v-4.71l-.86.91-.28-.29,1.18-1.24h.41v5.33Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.17,423.39a1.88,1.88,0,0,1,1.87-2,1.62,1.62,0,0,1,1.37.66l-.29.26a1.21,1.21,0,0,0-1.06-.54,1.66,1.66,0,0,0,0,3.3,1.24,1.24,0,0,0,1.06-.54l.29.25a1.6,1.6,0,0,1-1.37.67A1.89,1.89,0,0,1,350.17,423.39Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.93,425.32v-2.7c0-.54-.23-.88-.77-.88a1.43,1.43,0,0,0-1.11.66v2.92h-.42v-2.7c0-.54-.22-.88-.77-.88a1.49,1.49,0,0,0-1.11.66v2.92h-.41v-3.86h.41V422a1.73,1.73,0,0,1,1.25-.68,1,1,0,0,1,1,.73,1.62,1.62,0,0,1,1.28-.73c.72,0,1.06.4,1.06,1.18v2.78Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.27,425.32l-1.28-1.7-1.29,1.7h-.49l1.53-2-1.44-1.88h.49l1.2,1.59,1.19-1.59h.5l-1.44,1.88,1.53,2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.42,425.32V425c1.82-1.47,3-2.51,3-3.54a1.1,1.1,0,0,0-1.21-1.09,1.71,1.71,0,0,0-1.46.7l-.32-.29a2.18,2.18,0,0,1,1.78-.82,1.54,1.54,0,0,1,1.68,1.5c0,1.18-1.24,2.25-2.78,3.5h2.8v.41Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.36,424.73l.27-.33a1.32,1.32,0,0,0,1.17.59c1.17,0,1.57-1.22,1.57-2.34v-.25a2,2,0,0,1-1.56.89,1.58,1.58,0,0,1-1.72-1.69,1.7,1.7,0,0,1,1.79-1.7c1.44,0,2,1.33,2,2.76s-.57,2.75-2,2.75A1.7,1.7,0,0,1,373.36,424.73Zm3-2.76c-.06-.73-.44-1.65-1.45-1.65a1.28,1.28,0,0,0-1.34,1.28,1.21,1.21,0,0,0,1.34,1.28A1.72,1.72,0,0,0,376.34,422Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.53,425a.36.36,0,0,1,.36-.34.35.35,0,1,1,0,.69A.36.36,0,0,1,377.53,425Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.24,425.32l2.24-4.92h-3V420H382v.32l-2.28,5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.71,423.39a1.89,1.89,0,0,1,1.87-2A1.61,1.61,0,0,1,386,422l-.29.26a1.21,1.21,0,0,0-1.05-.54,1.66,1.66,0,0,0,0,3.3,1.23,1.23,0,0,0,1.05-.54l.29.25a1.59,1.59,0,0,1-1.37.67A1.89,1.89,0,0,1,382.71,423.39Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.48,425.32v-2.7c0-.54-.24-.88-.78-.88a1.41,1.41,0,0,0-1.1.66v2.92h-.43v-2.7c0-.54-.22-.88-.76-.88a1.47,1.47,0,0,0-1.11.66v2.92h-.42v-3.86h.42V422a1.69,1.69,0,0,1,1.24-.68,1,1,0,0,1,1,.73,1.59,1.59,0,0,1,1.28-.73c.71,0,1.05.4,1.05,1.18v2.78Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.68,426.72a7,7,0,0,0,.85-3.34,7.08,7.08,0,0,0-.85-3.36l.25-.18a6.37,6.37,0,0,1,0,7.07Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.16,50.71l-.7.1a2.06,2.06,0,0,1-.34.07c-.27,0-.41-.33-.78-.41-.09,0,0,0-.14,0s0,0-.17-.09c0,.25-.06.18-.06.37a1.39,1.39,0,0,0,.15.63c.07.14.1.09.1.29,0,.38-.06.48.1.79a1.89,1.89,0,0,1,.28.57c.37,0,.31,0,.36.11.34,0,.12-.08.31-.11,0,0,.35.08.26-.36.26.07.14.21.31.19s.07-.13.09-.29-.07,0,.18-.16l-.06-.31c0-.37.09,0,.21,0l.15-1.1c0-.08.12,0-.1-.35C54.08,50.69,54.21,50.69,54.16,50.71Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.26,49.78c0,.14.08.08-.1.1l.21.46c.09,0,.06,0,.2,0,0-.32,0-.21-.1-.37S54.4,49.81,54.26,49.78Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.66,49.36c-.06.21,0,0-.07.17s-.09.46.22.3C51.81,49.46,51.85,49.49,51.66,49.36Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.65,45.68a1.89,1.89,0,0,0-.63.1c-.39.1-.22.18-.1.36a2.37,2.37,0,0,0,.91-.13c.16,0,.18,0,.08-.18h-.26Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.18,43.13a1.21,1.21,0,0,0,0-.18l-.59-.22c-.42-.16-.85-.31-1.26-.48s-.85-.35-1.32-.58-1-.51-1.54-.84a3.47,3.47,0,0,1-1.26-1.43,4.69,4.69,0,0,1-.28-.72h-.1a2.66,2.66,0,0,0-.57.07l-.54.14a6.65,6.65,0,0,1-1.45.27H49l-.55,0-.42,0c-.3,0-.59-.1-.87-.16l-.3-.07-.24.28a.57.57,0,0,1,.16.15,1,1,0,0,1,.22,1,1.58,1.58,0,0,1-1.36,1l-.49,0h-.09a1.69,1.69,0,0,1-1.34-.88,1.19,1.19,0,0,1,.1-1.3l0,0a3.53,3.53,0,0,1,.21-.32,3.07,3.07,0,0,0,.25-.38l.13-.28A1.79,1.79,0,0,1,43,37,3.87,3.87,0,0,1,42.74,36l-.15,0-.24.06a2.75,2.75,0,0,1-.2.23,1.34,1.34,0,0,1-.93.43,1.13,1.13,0,0,1-.36-.06H40.8a1.18,1.18,0,0,1-.69-.22.77.77,0,0,1-.39-.27.89.89,0,0,1-.18-.77,3.22,3.22,0,0,1,.6-1.29.43.43,0,0,1,.07-.1,1.23,1.23,0,0,1,.36-.74c.16-.16.32-.29.47-.42l.13-.11c.07-.06.16-.14.26-.21a1.56,1.56,0,0,1,.25-.69,2.85,2.85,0,0,1,.86-.83,4.86,4.86,0,0,1,.53-.31l.26-.15.24-.14.14-.09a.75.75,0,0,1,.41-.12.73.73,0,0,1,.33.08.81.81,0,0,1,.46.93s-.2.69-.27.91a2.08,2.08,0,0,1-.38.72c.17.11.37.24.56.39a3.6,3.6,0,0,1,.45.41h.33l.12,0a2.68,2.68,0,0,0,.82-.37l.12-.07a6.94,6.94,0,0,1,1.62-.77A10.91,10.91,0,0,1,51.16,32h.37c.54,0,1.07,0,1.57,0a8.75,8.75,0,0,1,1.19.16,7.05,7.05,0,0,1,2.88,1.25.56.56,0,0,0-.29-.4c-.15-.07-.07,0-.18-.09a0,0,0,0,1,0,0l-.12-.09c-.18-.12-.15,0-.22-.26l-.07,0,0,0c-.11,0-.08-.21-.18-.34s0,.1-.23,0,0,0-.08-.06a.25.25,0,0,0-.11,0l-.09,0c-.43-.18-.35-.25-.35-.68-.37-.1-.15-.38-.12-.62s-.19-.43-.09-.84c-.52,0-.31-.51-.46-1.06l0-.5c0-.11,0,.05.06-.15l-.14-.06c-.48-.29-.39-.52-.53-.61l-.36.11c-.11.08,0,.05-.16.09-.35-.32-.18-1-.3-1.42,0-.18-.08-.43-.33-.49a.75.75,0,0,1,.16-.31c-.13-.06-.19-.05-.31-.11a1.51,1.51,0,0,0-.16-.83c-.1-.17,0-.18-.26-.21-.06.25,0,.1-.26.21a1.48,1.48,0,0,1-.19.8s0,0,0,0l0,.06a1.06,1.06,0,0,0-.22.51h.15c0,.24,0,.1-.11.25s-.06,0,0,.25-.18.29-.16.58.08.13.08.32-.06.15-.05.29c0,.39.16.29,0,.67s-.11.76-.35,1.15-.2.46-.27.56a.74.74,0,0,1-.58.23,2.16,2.16,0,0,1-.53-.26c-.1-.05-.18-.08-.22-.18s0-.07-.07-.15c-.12-.26-.46-.24-.71-.33s-.33-.44-.93-.68l-.31-.1-.25-.17-.2-.22c-.06-.05-.17-.11-.24-.17L46.43,28c-.21-.11-.18,0-.19-.29.12,0,.25-.25.35-.39a.47.47,0,0,0,.06-.09l0-.11s0,0,0,0l.11-.25c-.22-.09,0,0-.21-.06.08-.12.06,0,.11-.2.26-.13.2-.06.36,0,.31-.46.13-.17.2-.44s.21-.27.32-.44l-.19-.12c-.22-.12-.17.08-.17-.3a1,1,0,0,0-.42.31c-.06-.07-.06.11-.06-.15a.78.78,0,0,1-.26.1c.16-.2.09,0,.16-.21a1.49,1.49,0,0,0-.68.26c-.13-.09-.2-.08-.26-.26-.26,0-.07,0-.3.11a1.19,1.19,0,0,0-.42-.21v-.1c-.28,0-.46.17-.7-.09,0,0-.11-.19-.14-.22-.19,0-.1,0-.26.15a.39.39,0,0,0-.23-.29c-.08-.06,0,0-.1,0l-.29,0s.07,0-.16.05v.16c.2,0,0,0,.15.06a.05.05,0,0,0,0,0,0,0,0,0,0,0,0c.15.07.16,0,.41,0a1.21,1.21,0,0,1,.1.47l-.38.13,0,0L43,25.6c-.2,0-.13-.05-.21-.2l-.13.07-.14.08c-.15.11.08,0-.17.13a.47.47,0,0,1-.24,0c0,.13,0,.13-.11.29s0,.16-.26.18c0,.37,0,.16.11.41l-.17.06c-.26.06-.13.06-.23.32s-.22.08-.32.56c.16.11.2.11.23.22a.42.42,0,0,1,0,.19c-.5,0-.28,0-.46,0a2.13,2.13,0,0,0-.58-.09c0,.38,0,.12-.11.22l0,0-.08.12c0-.36.08-.11.1-.41-.44-.13-.42-.59-.87-.67s0-.1-.38-.11c-.09.19,0,.23-.21.36.06-.25,0-.08,0-.16s-.11.06-.26.16c0-.24-.06-.2-.26-.1,0,.15,0,.1.16.15a.67.67,0,0,0-.11.31L38,27.47c-.13.27,0,.18-.19.32l-.07,0-.16.11c.08.28.14,0,.06.26-.18,0-.19.07-.32.23,0,0,0,0,0,0l0,.05-.08.07c-.08.07-.17.1-.19.26a.45.45,0,0,0,.13.3c-.12.14-.1.09-.11.31l-.23-.08c-.24-.05-.11.13-.18-.07h-.26c0,.35-.13.27-.06.42s.19.13.32.3c-.13.06,0,0-.21,0,0,.28.06.09,0,.37-.16-.12-.08-.09-.26-.42s-.19-.12-.16-.47c-.21.07-.2.17-.31.32l-.25.26a.91.91,0,0,0-.2.42c0,.15.09.23.09.51,0,0,0,0,0,0l.14,0c0,.11,0,.06-.08.13a.21.21,0,0,1,0,.06c-.08.08,0,0-.09.07l-.08.07,0,0-.06,0c-.13.11-.1.12-.16.26l0,.07c-.31.82-.5.82-1.43,1.17-.17.06,0,0-.19.06s-.14-.13-.35,0,0,.12-.21.26-.29-.09-.78.41a.44.44,0,0,1-.32.13c-.27,0-.07-.15-.42.07,0-.27.06-.09-.1-.16,0,.17,0,.14-.17.25-.32.23-.06-.07-.52.43l-.05.05-.16.2s0,0,0,.06c-.24.27-.77.16-.77,1h-.15a4,4,0,0,1-.05-.57,1.19,1.19,0,0,0-.37.93c.17.06,0-.09.14.13a.75.75,0,0,1,0,.64.59.59,0,0,0-.1.28v.37c0,.12,0,.09.17.23s0,.19.26.46l0,0a2,2,0,0,1,.13.18c.21.27.3.13.3.75h-.11a.85.85,0,0,0-.58-.68c0,.48.13.16.17.52-.13-.07-.06-.06-.21-.1,0,.27,0,.09-.11.16.34.5.87.69,1,1.34.05.29.36.44.46.68s0,0,.09.17.1.09.16.15a.76.76,0,0,1,.17.45c.18,1.1.84,1.33.91,2v.38c0,.23,0,.19.09.42s0,.31-.08.48a1.46,1.46,0,0,1-.31,0c0,.37,0,.71.32.71s.59.53,1.31.41a3,3,0,0,0,.8-.1.86.86,0,0,0,.3-.33l0,0,.07-.09,0-.05.15-.09c.12,0,.32,0,.37-.18v-.1c.07-.29.49-.28.75-.38l.6-.08h.12c.19,0,0,0,.14,0l.08,0,0,0c.18.08-.14,0,.19.06.05-.11.11-.17.44-.16s.6.16.77-.54a.45.45,0,0,1,.1-.27c.13-.15.21-.09.42-.21.83-.48.5-.56,1.44-.58a2.59,2.59,0,0,0,1-.3c.61-.25.55-.42,1.5-.42a2.3,2.3,0,0,0,.6-.09c.22,0,.68.33.86.45.3-.08.14-.22.5,0a1.93,1.93,0,0,0,.64.15c.07.16,0,0,0,.26.17,0,.17-.07.31,0,0,.11-.1.07-.13.19l.11.29c.13.12.23,0,.36.16s.08.23.27.46a.8.8,0,0,1,.17.51s0,0,0,0h-.05l-.13.14c.31,0,.23.23.51.29l.11,0s0,0,.1,0l0-.2c0-.16,0-.21.31-.57s.55-.24.7-.51a1.18,1.18,0,0,1,.23-.39c.13-.13,0,.06.11-.14,0,0,0,0,0,0s0,0,.05.06a.62.62,0,0,1,.08.12c-.15,0-.13,0-.2.1.1.24.11.21,0,.35a1.22,1.22,0,0,0-.26.82c0,.31-.07.24-.36.24-.05.19-.08.14-.11.36a1.29,1.29,0,0,0,.37-.1c.22-.06.25.12.37-.16l.2-.62.1.16s0,0,0,0l0,.06v0c.29.58-.19.6-.22.94a1.5,1.5,0,0,0,.52-.1l0,0s0,0,0,0c.32.27.67.63.52,1.1v.29a.87.87,0,0,0,.22.33l.21.35c.17.18.4.1.59.31l.14.16c.15,0,.15-.11.32-.07l.11,0,.05,0c.13,0,.06,0,.19.06s.53.29.58.41c.29,0,.85-.74,1-.21.26,0,.27-.18.48-.2l0,.07c-.07.15,0-.1-.07.19l.25.22.07.07.16.06c.06,0,.07.13.1.22a.27.27,0,0,0,.15-.37c.61,0,.79-.61,1.44-.59.42,0,.75.15,1-.09l.11-.15c.08-.18,0-.23,0-.39l.28-.75a1,1,0,0,1,.55-.67c.15-.13,0,0,.05-.14v0l0-.14a1.13,1.13,0,0,1,.28-.49c.31-.25.18-.43.64-.92l.3-.17,0,0,.11-.07C58.32,43.85,58.25,43.49,58.18,43.13Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.28,31Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.87,34.36a5,5,0,0,0-.53-.51,7.39,7.39,0,0,0-.8-.53,1.74,1.74,0,0,0-.4-.15.79.79,0,0,0-.26,0,1.71,1.71,0,0,1,.44-.49,1.52,1.52,0,0,0,.57-.77c.09-.3.17-.6.26-.9l0,0-.4.25-.76.43a2.12,2.12,0,0,0-.62.61.89.89,0,0,0-.13.63c0,.16-.07.16-.07.16a1.1,1.1,0,0,0-.46.27c-.19.16-.38.32-.55.49a.42.42,0,0,0-.14.28.89.89,0,0,1-.22.47,2.45,2.45,0,0,0-.46,1c0,.13,0,.18.17.15a.36.36,0,0,0,.41.16s0,0,.06,0c.27.13.4.11.65-.13a1.06,1.06,0,0,0,.17-.2c.13-.19.33-.2.52-.26a1.56,1.56,0,0,0,.64-.25s.15-.12.21,0a2.56,2.56,0,0,1,.26.34,2,2,0,0,1,.12.49,3.08,3.08,0,0,0,.18,1,1,1,0,0,0,1.19.63,2,2,0,0,1,1,0l.2.09-.39,0a.13.13,0,0,0-.13.09c-.18.43-.35.86-.56,1.27s-.34.51-.5.76-.23.34-.12.52a.91.91,0,0,0,.72.51l.53,0a.79.79,0,0,0,.61-.45.28.28,0,0,0-.08-.29c-.05.13-.15.15-.26.17a.45.45,0,0,0-.18.07c0-.12.11-.11.21-.14l0-.23-.06,0c-.11.15-.17.17-.35.11l-.14,0c-.15-.05-.18,0-.19.12a.34.34,0,0,0,0,.11.3.3,0,0,1,0-.4,8.32,8.32,0,0,1,.6-.71,7.84,7.84,0,0,0,1.23-1.63,1,1,0,0,0,.11-.3.59.59,0,0,0-.28-.61,5.55,5.55,0,0,0-.74-.44.51.51,0,0,1-.32-.61l.07.2c0,.18.23.24.37.32s.49.23.72.36a.72.72,0,0,1,.23,1.15l-.38.61c0,.07,0,.12.07.14.42.08.83.19,1.25.24a5.79,5.79,0,0,0,1,0A10.71,10.71,0,0,0,51,38a2.67,2.67,0,0,1,1.09-.06l.08,0-.06-.58c0-.16,0-.32,0-.49a4,4,0,0,0-.39-1.58,1.75,1.75,0,0,0-.16-.25.9.9,0,0,1,.35.32,1.87,1.87,0,0,1,.3.78c.09.48.15,1,.23,1.44a5.17,5.17,0,0,0,.43,1.5,2.73,2.73,0,0,0,1,1.12c.47.29,1,.55,1.47.8s.84.38,1.27.56l1.6.61.78.28a.47.47,0,0,1,.31.29l-.43-.21v0c0,.15.09.29.12.45.08.4.15.8.22,1.21s.11.63.15,1a4.53,4.53,0,0,1,0,.52,1.12,1.12,0,0,0,.25.73c0,.06.11.1.16.15a5.72,5.72,0,0,1,.91,1.12A1,1,0,0,0,61,48h.26s0-.06,0-.08a.3.3,0,0,1,0-.39,1,1,0,0,0,.12-.29c0-.17-.08-.29-.17-.41a1.47,1.47,0,0,0-.1-.13l-.21.28,0,0a.49.49,0,0,0,.07-.55.89.89,0,0,0-.35-.48.82.82,0,0,1-.4-.7c-.06-.36-.09-.72-.13-1.09a4.6,4.6,0,0,1-.05-.64c0-.31.07-.61.09-.92a.67.67,0,0,0-.19-.5A4,4,0,0,0,59,41.4c-.54-.37-1.08-.74-1.59-1.14a7.52,7.52,0,0,1-1.74-2,2.33,2.33,0,0,1-.29-.89,1.59,1.59,0,0,1,.09-.75,3.21,3.21,0,0,0,.18,1.3c.28-.07.53-.18.58-.48a2.12,2.12,0,0,0,0-.56c0-.17.06-.27.23-.23a.87.87,0,0,1,.54.41c.43.63.83,1.28,1.25,1.92.25.4.5.79.76,1.18s.71,1,1.08,1.53a9.45,9.45,0,0,0,.66.76c.2.22.42.43.64.64a7.69,7.69,0,0,0,1.4,1.06,8,8,0,0,0,2,.87,13,13,0,0,0,1.48.32,7.5,7.5,0,0,0,1.25.08,9.91,9.91,0,0,0,1.32-.16,7.24,7.24,0,0,0,2-.68,9.68,9.68,0,0,0,.88-.52s.05,0,.05-.06l0-.2c-.06,0-.12,0-.17,0a3.71,3.71,0,0,0-.46.19,9,9,0,0,1-1.67.6,7.93,7.93,0,0,1-1.16.23,11.1,11.1,0,0,1-1.29,0,5.32,5.32,0,0,1-2.21-.63,7,7,0,0,1-1.49-1l-.49-.47a10.89,10.89,0,0,1-1.18-1.44,19.25,19.25,0,0,1-1.24-2l-.83-1.53a14.16,14.16,0,0,0-1.36-2.12,8.83,8.83,0,0,0-1.06-1.14,6.21,6.21,0,0,0-3-1.43,7.94,7.94,0,0,0-1.09-.15c-.62,0-1.25-.06-1.87,0a10.57,10.57,0,0,0-2.68.38,7,7,0,0,0-1.56.76,3.67,3.67,0,0,1-1,.47,1.43,1.43,0,0,1-.29,0,4.22,4.22,0,0,0-.62,0Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.12,26.14h-.42v1.19h-.24V26.14H112v-.25h1.09Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.66,25.89v1.44h-.25v-1l-.47.73-.47-.73v1h-.25V25.89h.27l.45.7.45-.7Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.4,29.61v.46a3.37,3.37,0,0,0-.82-.44,3.12,3.12,0,0,0-1-.17,3.25,3.25,0,0,0-1.23.23,2.92,2.92,0,0,0-1,.66,2.74,2.74,0,0,0-.64,1,3.17,3.17,0,0,0,0,2.37,2.84,2.84,0,0,0,.64,1,2.76,2.76,0,0,0,1,.65,3.07,3.07,0,0,0,1.23.24h.12a3.41,3.41,0,0,0,1.24-.23V33.66h0a1.75,1.75,0,0,1-.57.37,1.89,1.89,0,0,1-.67.12l-.28,0h0A2.22,2.22,0,0,1,73,34a1.56,1.56,0,0,1-.57-.37,1.54,1.54,0,0,1-.51-1.16,1.58,1.58,0,0,1,.51-1.18,1.89,1.89,0,0,1,1.24-.48,1.75,1.75,0,0,1,1.24.48,1.58,1.58,0,0,1,.51,1.18v3h1.45V29.61Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.23,35.53,66,32.42v3.11H64.55v-8.2H66v3.1l3.22-3.09h2.06L67,31.42l4.25,4.11Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.64,29.46a2.74,2.74,0,0,1,1.08.21,2.46,2.46,0,0,1,.83.59,2.58,2.58,0,0,1,.53.87,2.85,2.85,0,0,1,.19,1.06v3.34H81.81V32.19a1.24,1.24,0,0,0-.42-1,1.41,1.41,0,0,0-1-.39,1.4,1.4,0,0,0-1,.39,1.26,1.26,0,0,0-.42,1v3.34H77.52V29.62H79v.44a3.22,3.22,0,0,1,.74-.44A2.52,2.52,0,0,1,80.64,29.46Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.37,29.62a2.52,2.52,0,0,1,1-.17v1.38a1.74,1.74,0,0,0-1.24.48,1.61,1.61,0,0,0-.51,1.18v3H98.14V29.61H99.6v.45A2.91,2.91,0,0,1,100.37,29.62Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.64,29.46a3.43,3.43,0,0,1,1.25.23,3.2,3.2,0,0,1,1,.66,3,3,0,0,1,.69,1,3,3,0,0,1,0,2.37,3.13,3.13,0,0,1-.69,1,3,3,0,0,1-1,.65,3.24,3.24,0,0,1-1.25.24,3.27,3.27,0,0,1-1.25-.24,3,3,0,0,1-1-.65,3,3,0,0,1-.68-1,2.93,2.93,0,0,1,0-2.37,2.85,2.85,0,0,1,.68-1,3.2,3.2,0,0,1,1-.66A3.47,3.47,0,0,1,104.64,29.46Zm0,1.38a1.75,1.75,0,0,0-1.24.48,1.58,1.58,0,0,0-.51,1.18,1.54,1.54,0,0,0,.51,1.16A1.56,1.56,0,0,0,104,34a1.89,1.89,0,0,0,.67.12,1.85,1.85,0,0,0,.67-.12,1.75,1.75,0,0,0,.57-.37,1.54,1.54,0,0,0,.51-1.16,1.58,1.58,0,0,0-.51-1.18A1.81,1.81,0,0,0,104.64,30.84Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.45,29.46a3.43,3.43,0,0,1,1.25.23,3.2,3.2,0,0,1,1,.66,3,3,0,0,1,.69,1,2.93,2.93,0,0,1,0,2.37,3.13,3.13,0,0,1-.69,1,3,3,0,0,1-1,.65,3.24,3.24,0,0,1-1.25.24,3.27,3.27,0,0,1-1.25-.24,3.22,3.22,0,0,1-1-.65,3,3,0,0,1-.68-1,2.93,2.93,0,0,1,0-2.37,2.85,2.85,0,0,1,.68-1,3.19,3.19,0,0,1,2.27-.89Zm0,1.38a1.73,1.73,0,0,0-1.23.48,1.58,1.58,0,0,0-.51,1.18,1.54,1.54,0,0,0,.51,1.16,1.61,1.61,0,0,0,.56.37,1.89,1.89,0,0,0,.67.12,1.85,1.85,0,0,0,.67-.12,1.75,1.75,0,0,0,.57-.37,1.54,1.54,0,0,0,.51-1.16,1.58,1.58,0,0,0-.51-1.18A1.81,1.81,0,0,0,111.45,30.84Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.88,29.61v.46A3,3,0,0,0,94,29.46a3.32,3.32,0,0,0-1.23.23,3,3,0,0,0-1,.66,2.91,2.91,0,0,0-.65,1,3.17,3.17,0,0,0,0,2.37,3,3,0,0,0,.65,1,2.81,2.81,0,0,0,1,.65,3.14,3.14,0,0,0,1.23.24h.13a3.41,3.41,0,0,0,1.24-.23V33.66h0a1.75,1.75,0,0,1-.57.37,1.84,1.84,0,0,1-.66.12l-.29,0h0a2.79,2.79,0,0,1-.39-.1,1.61,1.61,0,0,1-.56-.37,1.54,1.54,0,0,1-.51-1.16,1.58,1.58,0,0,1,.51-1.18,1.71,1.71,0,0,1,.56-.35,1.75,1.75,0,0,1,.68-.13,1.73,1.73,0,0,1,1.23.48,1.58,1.58,0,0,1,.51,1.18v3h1.46V29.61Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.83,29.61h0v.45a3.37,3.37,0,0,0-.82-.44,2.83,2.83,0,0,0-.52-.13,3.22,3.22,0,0,0-.63-.05,3.18,3.18,0,0,0-1.21.23,2.91,2.91,0,0,0-1.56,1.62,3.35,3.35,0,0,0-.21,1.19h0a3,3,0,0,0,.23,1.18,2.84,2.84,0,0,0,.64,1,2.76,2.76,0,0,0,1,.65,3.07,3.07,0,0,0,1.23.24h.21a3.36,3.36,0,0,0,1.15-.23V33.66h0a1.75,1.75,0,0,1-.57.37,1.89,1.89,0,0,1-.67.12l-.28,0h0a2.22,2.22,0,0,1-.39-.1,1.71,1.71,0,0,1-1.08-1.54,1.54,1.54,0,0,1,.12-.61l0-.05a2,2,0,0,1,.37-.51,1.89,1.89,0,0,1,1.24-.48,1.75,1.75,0,0,1,1.24.48,2,2,0,0,1,.37.51l0,.05a1.59,1.59,0,0,1,.12.62v2.3A1.55,1.55,0,0,1,88.32,36a1.7,1.7,0,0,1-1.24.49,1.6,1.6,0,0,1-.87-.23l-1.06,1a3,3,0,0,0,.9.46,3.13,3.13,0,0,0,1,.17,3.1,3.1,0,0,0,1.25-.25,3.36,3.36,0,0,0,1-.65A3,3,0,0,0,90,36a2.78,2.78,0,0,0,.25-1.18V29.62H88.83Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.24,40.54v.39H64.55V38.72h1.62v.39H65v.56h1v.38H65v.49Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69,38.54V40.9H68.6v-.1a1,1,0,0,1-.5.13.88.88,0,0,1,0-1.76,1.06,1.06,0,0,1,.5.13v-.76Zm-.43,1.85V39.7a.73.73,0,0,0-.42-.14.49.49,0,0,0-.51.49.48.48,0,0,0,.51.48A.66.66,0,0,0,68.6,40.39Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.81,39.2v1.7h-.44v-.11a.76.76,0,0,1-.46.14c-.5,0-.72-.23-.72-.78V39.2h.43v.95c0,.26.13.39.37.39a.54.54,0,0,0,.38-.14V39.2Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.49,40.59a.83.83,0,0,1-.66.34.88.88,0,1,1,0-1.76.81.81,0,0,1,.66.34l-.28.26a.44.44,0,0,0-.38-.21.49.49,0,1,0,0,1,.46.46,0,0,0,.38-.21Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.27,39.2v1.7h-.43v-.12a.92.92,0,0,1-.5.15.88.88,0,0,1,0-1.76,1.07,1.07,0,0,1,.5.14V39.2Zm-.43.51a.67.67,0,0,0-.42-.15.49.49,0,0,0-.51.49.5.5,0,0,0,.51.49.67.67,0,0,0,.42-.15Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79,39.56v.6c0,.31,0,.39.27.39h.2v.32a.93.93,0,0,1-.4.07.49.49,0,0,1-.51-.54v-.83H78.3V39.2h.24v-.66H79v.66h.47v.36Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.49,38.79a.25.25,0,1,1,.5,0,.25.25,0,1,1-.5,0Zm0,.44H81v1.7h-.44Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.92,40.05a.93.93,0,1,1-.93-.88A.91.91,0,0,1,83.92,40.05Zm-.43,0a.5.5,0,1,0-.5.49A.49.49,0,0,0,83.49,40.05Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.62,40v1h-.43V40c0-.26-.13-.39-.37-.39a.55.55,0,0,0-.37.13v1.21H85v-1.7h.44v.11a.75.75,0,0,1,.45-.14C86.4,39.2,86.62,39.43,86.62,40Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90,39.11v.78h1v.39H90v.65H89.6V38.72h1.66v.39Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.07,40.05a.93.93,0,1,1-.93-.88A.91.91,0,0,1,94.07,40.05Zm-.43,0a.49.49,0,0,0-.5-.49.49.49,0,1,0,0,1A.49.49,0,0,0,93.64,40.05Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.77,39.2v1.7h-.44v-.11a.78.78,0,0,1-.46.14c-.5,0-.73-.23-.73-.78V39.2h.44v.95c0,.26.13.39.37.39a.56.56,0,0,0,.38-.14V39.2Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.56,40v1h-.44V40c0-.26-.13-.39-.37-.39a.57.57,0,0,0-.37.13v1.21h-.44v-1.7h.44v.11a.75.75,0,0,1,.45-.14C99.33,39.2,99.56,39.43,99.56,40Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.43,38.54V40.9H102v-.1a1,1,0,0,1-.49.13.88.88,0,0,1,0-1.76,1,1,0,0,1,.49.13v-.76ZM102,40.39V39.7a.68.68,0,0,0-.42-.14.48.48,0,0,0-.5.49.47.47,0,0,0,.5.48A.63.63,0,0,0,102,40.39Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.3,39.2v1.7h-.43v-.12a.92.92,0,0,1-.5.15.88.88,0,0,1,0-1.76,1,1,0,0,1,.5.14V39.2Zm-.43.51a.67.67,0,0,0-.42-.15.48.48,0,0,0-.5.49.49.49,0,0,0,.5.49.65.65,0,0,0,.42-.15Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107,39.56v.6c0,.31,0,.39.27.39h.2v.32a.93.93,0,0,1-.4.07.49.49,0,0,1-.51-.54v-.83h-.24V39.2h.24v-.66H107v.66h.47v.36Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.52,38.79a.25.25,0,1,1,.5,0,.25.25,0,1,1-.5,0Zm0,.44H109v1.7h-.43Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112,40.05a.93.93,0,1,1-.93-.88A.91.91,0,0,1,112,40.05Zm-.43,0a.5.5,0,1,0-.5.49A.49.49,0,0,0,111.52,40.05Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.66,40v1h-.44V40c0-.26-.13-.39-.37-.39a.55.55,0,0,0-.37.13v1.21H113v-1.7h.44v.11a.75.75,0,0,1,.45-.14C114.43,39.2,114.66,39.43,114.66,40Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "300.77 425.32 257.82 353.74 214.87 425.32 300.77 425.32"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 138.99,
    x2: 300.77,
    y2: 138.99
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 425.32,
    x2: 300.77,
    y2: 425.32
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 396.69,
    x2: 300.77,
    y2: 396.69
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 368.06,
    x2: 300.77,
    y2: 368.06
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 339.42,
    x2: 300.77,
    y2: 339.42
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 310.79,
    x2: 300.77,
    y2: 310.79
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 282.16,
    x2: 300.77,
    y2: 282.16
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 253.53,
    x2: 300.77,
    y2: 253.53
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 224.89,
    x2: 300.77,
    y2: 224.89
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 196.26,
    x2: 300.77,
    y2: 196.26
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 167.63,
    x2: 300.77,
    y2: 167.63
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 411.01,
    x2: 300.77,
    y2: 411.01
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 382.37,
    x2: 300.77,
    y2: 382.37
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 353.74,
    x2: 300.77,
    y2: 353.74
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 325.11,
    x2: 300.77,
    y2: 325.11
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 296.47,
    x2: 300.77,
    y2: 296.47
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 267.84,
    x2: 300.77,
    y2: 267.84
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 239.21,
    x2: 300.77,
    y2: 239.21
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 210.58,
    x2: 300.77,
    y2: 210.58
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 181.94,
    x2: 300.77,
    y2: 181.94
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 153.31,
    x2: 300.77,
    y2: 153.31
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 138.99,
    x2: 300.77,
    y2: 138.99
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 0.13,
    y2: 425.32
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 286.45,
    y1: 0.13,
    x2: 286.45,
    y2: 425.32
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 28.76,
    y1: 0.13,
    x2: 28.76,
    y2: 425.32
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 57.39,
    y1: 0.13,
    x2: 57.39,
    y2: 425.32
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 86.02,
    y1: 0.13,
    x2: 86.02,
    y2: 425.32
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 114.66,
    y1: 0.13,
    x2: 114.66,
    y2: 425.32
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 143.29,
    y1: 0.13,
    x2: 143.29,
    y2: 425.32
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 171.92,
    y1: 0.13,
    x2: 171.92,
    y2: 425.32
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.55,
    y1: 0.13,
    x2: 200.55,
    y2: 425.32
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 229.19,
    y1: 0.13,
    x2: 229.19,
    y2: 425.32
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 257.82,
    y1: 0.13,
    x2: 257.82,
    y2: 425.32
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 14.44,
    y1: 0.13,
    x2: 14.44,
    y2: 425.32
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 43.07,
    y1: 0.13,
    x2: 43.07,
    y2: 425.32
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 71.71,
    y1: 0.13,
    x2: 71.71,
    y2: 425.32
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 100.34,
    y1: 0.13,
    x2: 100.34,
    y2: 425.32
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 128.97,
    y1: 0.13,
    x2: 128.97,
    y2: 425.32
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 157.61,
    y1: 0.13,
    x2: 157.61,
    y2: 425.32
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 186.24,
    y1: 0.13,
    x2: 186.24,
    y2: 425.32
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 214.87,
    y1: 0.13,
    x2: 214.87,
    y2: 425.32
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 243.5,
    y1: 0.13,
    x2: 243.5,
    y2: 425.32
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 272.14,
    y1: 0.13,
    x2: 272.14,
    y2: 425.32
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 300.77,
    y1: 0.13,
    x2: 300.77,
    y2: 425.32
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 110.36,
    x2: 300.77,
    y2: 110.36
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 81.73,
    x2: 300.77,
    y2: 81.73
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 53.1,
    x2: 300.77,
    y2: 53.1
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 24.46,
    x2: 300.77,
    y2: 24.46
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 124.68,
    x2: 300.77,
    y2: 124.68
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 96.04,
    x2: 300.77,
    y2: 96.04
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 67.41,
    x2: 300.77,
    y2: 67.41
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 38.78,
    x2: 300.77,
    y2: 38.78
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 10.15,
    x2: 300.77,
    y2: 10.15
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.86,387.22,29.94,386l-.24.29v.93h-.64v-3h.64v1.35l1.08-1.35h.79l-1.2,1.42,1.28,1.61Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.19,387.22V387a.91.91,0,0,1-.7.29.72.72,0,0,1-.75-.73.69.69,0,0,1,.75-.71.88.88,0,0,1,.7.27v-.28c0-.22-.19-.37-.48-.37a.91.91,0,0,0-.63.26l-.23-.4a1.38,1.38,0,0,1,1-.35c.5,0,1,.2,1,.83v1.42Zm0-.53v-.27a.58.58,0,0,0-.46-.19c-.23,0-.42.12-.42.33s.19.32.42.32A.58.58,0,0,0,33.19,386.69Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.82,387.22v-1.33a.36.36,0,0,0-.4-.41.63.63,0,0,0-.5.26v1.48h-.58V385h.58v.29a1,1,0,0,1,.77-.34.64.64,0,0,1,.71.7v1.55Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.93,387.78l.26-.41a.88.88,0,0,0,.68.27.54.54,0,0,0,.61-.56v-.22a.84.84,0,0,1-.68.34,1,1,0,0,1-1-1.11c0-.72.41-1.12,1-1.12a.84.84,0,0,1,.68.34V385h.58v2.06c0,.83-.65,1-1.19,1A1.28,1.28,0,0,1,36.93,387.78Zm1.55-1.34v-.71a.66.66,0,0,0-.49-.25.54.54,0,0,0-.56.61.54.54,0,0,0,.56.6A.66.66,0,0,0,38.48,386.44Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,387.22V387a.91.91,0,0,1-.7.29.73.73,0,0,1-.76-.73.7.7,0,0,1,.76-.71.88.88,0,0,1,.7.27v-.28c0-.22-.19-.37-.48-.37a.91.91,0,0,0-.63.26l-.23-.4a1.38,1.38,0,0,1,1-.35c.5,0,1,.2,1,.83v1.42Zm0-.53v-.27a.58.58,0,0,0-.46-.19c-.23,0-.42.12-.42.33s.19.32.42.32A.58.58,0,0,0,41,386.69Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.1,387.22V385h.58v.3a1,1,0,0,1,.7-.35v.56h-.16a.73.73,0,0,0-.54.25v1.45Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.59,386.12a1.17,1.17,0,1,1,1.16,1.16A1.12,1.12,0,0,1,43.59,386.12Zm1.73,0a.57.57,0,1,0-1.13,0,.57.57,0,1,0,1.13,0Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.21,386.12a1.16,1.16,0,1,1,1.16,1.16A1.11,1.11,0,0,1,46.21,386.12Zm1.72,0a.57.57,0,1,0-.56.64A.58.58,0,0,0,47.93,386.12Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.14,387.22v-3h2.15v.57h-1.5v.63h1.47V386H50.79v.69h1.5v.57Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.29,387.22v-.28a.84.84,0,0,1-.68.34c-.55,0-1-.42-1-1.16s.41-1.15,1-1.15a.83.83,0,0,1,.68.34v-1.12h.58v3Zm0-.71v-.78a.63.63,0,0,0-.5-.25.65.65,0,0,0,0,1.28A.6.6,0,0,0,54.29,386.51Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.93,387.22v-.28a1,1,0,0,1-.78.34.64.64,0,0,1-.71-.7V385H56v1.34c0,.3.16.4.41.4a.64.64,0,0,0,.5-.25V385h.57v2.2Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.94,386.12A1.12,1.12,0,0,1,59.1,385a1,1,0,0,1,.87.4l-.38.35a.53.53,0,0,0-.46-.24.64.64,0,0,0,0,1.28.53.53,0,0,0,.46-.24l.38.36a1,1,0,0,1-.87.4A1.12,1.12,0,0,1,57.94,386.12Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.66,387.22V387a.9.9,0,0,1-.69.29.73.73,0,0,1-.76-.73.7.7,0,0,1,.76-.71.86.86,0,0,1,.69.27v-.28c0-.22-.19-.37-.48-.37a.91.91,0,0,0-.63.26l-.23-.4a1.39,1.39,0,0,1,1-.35c.51,0,1,.2,1,.83v1.42Zm0-.53v-.27a.55.55,0,0,0-.46-.19c-.23,0-.41.12-.41.33s.18.32.41.32A.55.55,0,0,0,61.66,386.69Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.93,386.67v-1.14h-.36V385h.36v-.6h.58v.6H64v.51h-.44v1c0,.14.07.24.2.24a.28.28,0,0,0,.2-.07l.12.44a.7.7,0,0,1-.48.15A.55.55,0,0,1,62.93,386.67Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.29,384.44a.35.35,0,0,1,.35-.34.34.34,0,0,1,.34.34.35.35,0,0,1-.34.35A.35.35,0,0,1,64.29,384.44Zm.06,2.78V385h.58v2.2Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.36,386.12a1.16,1.16,0,0,1,2.32,0,1.16,1.16,0,1,1-2.32,0Zm1.72,0a.57.57,0,1,0-.56.64A.58.58,0,0,0,67.08,386.12Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.59,387.22v-1.33c0-.3-.15-.41-.4-.41a.63.63,0,0,0-.5.26v1.48h-.58V385h.58v.29a1,1,0,0,1,.77-.34.64.64,0,0,1,.72.7v1.55Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.93,387.22v-3h2.14v.57h-1.5v.63H74V386H72.57v1.26Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.37,386.12a1.16,1.16,0,0,1,2.32,0,1.16,1.16,0,0,1-2.32,0Zm1.72,0a.57.57,0,1,0-.56.64A.58.58,0,0,0,76.09,386.12Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.6,387.22v-.28a1,1,0,0,1-.77.34.64.64,0,0,1-.71-.7V385h.58v1.34a.35.35,0,0,0,.4.4.63.63,0,0,0,.5-.25V385h.58v2.2Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.24,387.22v-1.33a.36.36,0,0,0-.41-.41.63.63,0,0,0-.5.26v1.48h-.58V385h.58v.29a1,1,0,0,1,.77-.34.64.64,0,0,1,.72.7v1.55Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.89,387.22v-.28a.82.82,0,0,1-.67.34c-.55,0-1-.42-1-1.16a1,1,0,0,1,1-1.15.81.81,0,0,1,.67.34v-1.12h.59v3Zm0-.71v-.78a.62.62,0,0,0-.49-.25.65.65,0,0,0,0,1.28A.6.6,0,0,0,83.89,386.51Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.37,387.22V387a.91.91,0,0,1-.7.29.73.73,0,0,1-.76-.73.7.7,0,0,1,.76-.71.88.88,0,0,1,.7.27v-.28c0-.22-.19-.37-.48-.37a.92.92,0,0,0-.64.26l-.22-.4a1.36,1.36,0,0,1,1-.35c.5,0,1,.2,1,.83v1.42Zm0-.53v-.27a.58.58,0,0,0-.47-.19c-.22,0-.41.12-.41.33s.19.32.41.32A.58.58,0,0,0,86.37,386.69Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.64,386.67v-1.14h-.37V385h.37v-.6h.57v.6h.45v.51h-.45v1c0,.14.08.24.2.24a.27.27,0,0,0,.2-.07l.13.44a.73.73,0,0,1-.49.15A.54.54,0,0,1,87.64,386.67Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89,384.44a.34.34,0,0,1,.68,0,.34.34,0,1,1-.68,0Zm0,2.78V385h.58v2.2Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.06,386.12a1.17,1.17,0,1,1,1.16,1.16A1.12,1.12,0,0,1,90.06,386.12Zm1.72,0a.57.57,0,0,0-.56-.64.65.65,0,0,0,0,1.28A.57.57,0,0,0,91.78,386.12Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.3,387.22v-1.33a.36.36,0,0,0-.41-.41.65.65,0,0,0-.5.26v1.48h-.57V385h.57v.29a1,1,0,0,1,.77-.34.64.64,0,0,1,.72.7v1.55Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.63,387.22v-3h1.42a1,1,0,1,1,0,1.95h-.77v1.08Zm1.78-2.05a.41.41,0,0,0-.45-.41h-.68v.81H98A.41.41,0,0,0,98.41,385.17Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99,386.9a.37.37,0,1,1,.37.37A.38.38,0,0,1,99,386.9Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.38,387.22v-3H102v2.46h1.29v.57Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.69,386.67v-1.14h-.37V385h.37v-.6h.58v.6h.44v.51h-.44v1c0,.14.07.24.2.24a.3.3,0,0,0,.2-.07l.12.44a.7.7,0,0,1-.48.15A.55.55,0,0,1,103.69,386.67Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.62,387.22v-.28a.86.86,0,0,1-.68.34c-.55,0-1-.42-1-1.16s.41-1.15,1-1.15a.84.84,0,0,1,.68.34v-1.12h.58v3Zm0-.71v-.78a.66.66,0,0,0-.5-.25.65.65,0,0,0,0,1.28A.63.63,0,0,0,106.62,386.51Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.7,386.9a.38.38,0,0,1,.37-.37.37.37,0,0,1,0,.74A.38.38,0,0,1,107.7,386.9Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.11,392.68v-3h1.22a.92.92,0,1,1,0,1.83h-.84v1.21Zm1.78-2.12a.56.56,0,0,0-.6-.58h-.8v1.15h.8A.55.55,0,0,0,30.89,390.56Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.05,392.68v-.25a.94.94,0,0,1-.73.3.73.73,0,0,1-.76-.73.71.71,0,0,1,.76-.72,1,1,0,0,1,.73.29v-.39c0-.29-.24-.46-.56-.46a.87.87,0,0,0-.67.3l-.16-.23a1.15,1.15,0,0,1,.88-.37c.47,0,.85.21.85.75v1.51Zm0-.47v-.42a.76.76,0,0,0-.6-.27.51.51,0,0,0-.55.48.5.5,0,0,0,.55.48A.73.73,0,0,0,33.05,392.21Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.67,392.68v-.33a.94.94,0,0,1-.74.38c-.58,0-1-.44-1-1.15s.4-1.16,1-1.16a.93.93,0,0,1,.74.39v-1.17H36v3Zm0-.6v-1a.82.82,0,0,0-.66-.35c-.44,0-.71.36-.71.85s.27.85.71.85A.82.82,0,0,0,35.67,392.08Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.34,392.68v-1.5c0-.27-.12-.45-.4-.45a.77.77,0,0,0-.59.34v1.61H38v-1.5c0-.27-.11-.45-.4-.45a.77.77,0,0,0-.58.34v1.61h-.34v-2.2H37v.32a1,1,0,0,1,.71-.38.56.56,0,0,1,.59.41.92.92,0,0,1,.74-.41c.4,0,.61.23.61.67v1.59Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.24,391.57a1.09,1.09,0,1,1,1.08,1.16A1.07,1.07,0,0,1,40.24,391.57Zm1.81,0a.74.74,0,1,0-1.46,0,.74.74,0,1,0,1.46,0Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.55,392.68v-.33a.92.92,0,0,1-.74.38c-.57,0-1-.44-1-1.15s.4-1.16,1-1.16a.91.91,0,0,1,.74.39v-1.17h.35v3Zm0-.6v-1a.79.79,0,0,0-.65-.35c-.45,0-.71.36-.71.85s.26.85.71.85A.79.79,0,0,0,44.55,392.08Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,392.68v-.25a.94.94,0,0,1-.73.3.73.73,0,0,1-.76-.73.71.71,0,0,1,.76-.72,1,1,0,0,1,.73.29v-.39c0-.29-.24-.46-.55-.46a.88.88,0,0,0-.68.3l-.16-.23a1.15,1.15,0,0,1,.88-.37c.47,0,.85.21.85.75v1.51Zm0-.47v-.42a.76.76,0,0,0-.6-.27.51.51,0,0,0-.55.48.5.5,0,0,0,.55.48A.73.73,0,0,0,47,392.21Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.91,393.23a.57.57,0,0,0,.18,0,.32.32,0,0,0,.33-.23l.15-.33-.92-2.22H48l.73,1.8.73-1.8h.37l-1.1,2.64a.67.67,0,0,1-.65.45.93.93,0,0,1-.24,0Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.58,392.68v-.25a1,1,0,0,1-.73.3.73.73,0,0,1-.76-.73.71.71,0,0,1,.76-.72,1,1,0,0,1,.73.29v-.39c0-.29-.24-.46-.56-.46a.86.86,0,0,0-.67.3l-.16-.23a1.15,1.15,0,0,1,.88-.37c.47,0,.85.21.85.75v1.51Zm0-.47v-.42a.77.77,0,0,0-.6-.27.5.5,0,0,0-.55.48.49.49,0,0,0,.55.48A.74.74,0,0,0,51.58,392.21Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.39,392.68v-2.56l-1,2.56H55.2l-1-2.56v2.56h-.38v-3h.55l.94,2.34.94-2.34h.54v3Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.33,391.57a1.09,1.09,0,1,1,1.09,1.16A1.08,1.08,0,0,1,57.33,391.57Zm1.81,0a.73.73,0,1,0-1.45,0,.74.74,0,1,0,1.45,0Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.65,392.68v-.33a.92.92,0,0,1-.74.38,1.17,1.17,0,0,1,0-2.31.93.93,0,0,1,.74.39v-1.17H62v3Zm0-.6v-1a.82.82,0,0,0-.66-.35c-.44,0-.7.36-.7.85s.26.85.7.85A.82.82,0,0,0,61.65,392.08Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.54,391.57a1.11,1.11,0,0,1,1.09-1.15,1.07,1.07,0,0,1,1.05,1.18v.09H62.91a.77.77,0,0,0,.79.76,1,1,0,0,0,.68-.28l.16.22a1.2,1.2,0,0,1-.87.34A1.09,1.09,0,0,1,62.54,391.57Zm1.08-.86a.73.73,0,0,0-.72.72h1.44A.7.7,0,0,0,63.62,390.71Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.29,393.25l-.17-.14a.68.68,0,0,0,.29-.42h-.06a.22.22,0,0,1-.22-.23.25.25,0,0,1,.24-.25c.16,0,.29.13.29.35A.87.87,0,0,1,65.29,393.25Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.44,392.68v-3h1.21a.92.92,0,1,1,0,1.83h-.84v1.21Zm1.77-2.12a.56.56,0,0,0-.6-.58h-.8v1.15h.8A.55.55,0,0,0,69.21,390.56Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.57,392.68v-.31a1.07,1.07,0,0,1-.78.36.62.62,0,0,1-.7-.7v-1.55h.34v1.45a.44.44,0,0,0,.5.5.82.82,0,0,0,.64-.34v-1.61h.34v2.2Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.66,392.22v-1.44H72.3v-.3h.36v-.6H73v.6h.44v.3H73v1.36c0,.17.07.29.22.29a.33.33,0,0,0,.23-.1l.1.26a.57.57,0,0,1-.41.14A.45.45,0,0,1,72.66,392.22Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.3,392.68v-.25a.92.92,0,0,1-.72.3.73.73,0,0,1-.77-.73.72.72,0,0,1,.77-.72.93.93,0,0,1,.72.29v-.39c0-.29-.23-.46-.55-.46a.86.86,0,0,0-.67.3l-.16-.23a1.13,1.13,0,0,1,.87-.37c.47,0,.85.21.85.75v1.51Zm0-.47v-.42a.76.76,0,0,0-.6-.27.5.5,0,0,0-.54.48.49.49,0,0,0,.54.48A.73.73,0,0,0,75.3,392.21Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.33,392.68v-3h.34v3Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.29,389.94a.23.23,0,0,1,.24-.23.23.23,0,0,1,0,.46A.23.23,0,0,1,77.29,389.94Zm.06,2.74v-2.2h.34v2.2Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.19,392.38l.17-.24a1,1,0,0,0,.72.31c.34,0,.53-.16.53-.37,0-.54-1.36-.21-1.36-1,0-.35.29-.64.81-.64a1.15,1.15,0,0,1,.82.32l-.16.24a.85.85,0,0,0-.66-.28c-.3,0-.48.15-.48.35,0,.47,1.36.16,1.36,1,0,.36-.3.66-.86.66A1.15,1.15,0,0,1,78.19,392.38Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.86,392.68v-.25a.92.92,0,0,1-.72.3.73.73,0,0,1-.77-.73.72.72,0,0,1,.77-.72,1,1,0,0,1,.72.29v-.39c0-.29-.23-.46-.55-.46a.88.88,0,0,0-.68.3l-.15-.23a1.11,1.11,0,0,1,.87-.37c.47,0,.85.21.85.75v1.51Zm0-.47v-.42a.76.76,0,0,0-.6-.27.5.5,0,0,0-.54.48.49.49,0,0,0,.54.48A.73.73,0,0,0,81.86,392.21Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.48,392.68v-.33a.92.92,0,0,1-.74.38,1.17,1.17,0,0,1,0-2.31.93.93,0,0,1,.74.39v-1.17h.34v3Zm0-.6v-1a.82.82,0,0,0-.65-.35c-.45,0-.71.36-.71.85s.26.85.71.85A.82.82,0,0,0,84.48,392.08Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.88,392.68v-.25a1,1,0,0,1-.73.3.73.73,0,0,1-.77-.73.72.72,0,0,1,.77-.72,1,1,0,0,1,.73.29v-.39c0-.29-.24-.46-.56-.46a.86.86,0,0,0-.67.3l-.16-.23a1.15,1.15,0,0,1,.88-.37c.47,0,.85.21.85.75v1.51Zm0-.47v-.42a.79.79,0,0,0-.6-.27.5.5,0,0,0-.55.48.49.49,0,0,0,.55.48A.76.76,0,0,0,86.88,392.21Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.4,392.68l-.79-1-.37.36v.63H87.9v-3h.34v2l1.16-1.17h.43l-1,1,1,1.2Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.33,393.25l-.17-.14a.68.68,0,0,0,.29-.42h-.06a.22.22,0,0,1-.22-.23.25.25,0,0,1,.24-.25c.16,0,.29.13.29.35A.87.87,0,0,1,90.33,393.25Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.31,392.68l-1.15-1.37-.31.35v1h-.37v-3h.37v1.57l1.34-1.57h.48l-1.27,1.44,1.38,1.6Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.49,392.68v-.25a.94.94,0,0,1-.73.3A.73.73,0,0,1,95,392a.71.71,0,0,1,.76-.72,1,1,0,0,1,.73.29v-.39c0-.29-.24-.46-.55-.46a.88.88,0,0,0-.68.3l-.16-.23a1.15,1.15,0,0,1,.88-.37c.47,0,.85.21.85.75v1.51Zm0-.47v-.42a.76.76,0,0,0-.6-.27.51.51,0,0,0-.55.48.5.5,0,0,0,.55.48A.73.73,0,0,0,96.49,392.21Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.58,392.22v-1.44h-.36v-.3h.36v-.6h.35v.6h.45v.3h-.45v1.36c0,.17.07.29.22.29a.31.31,0,0,0,.23-.1l.1.26a.56.56,0,0,1-.4.14A.46.46,0,0,1,97.58,392.22Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.34,392.68v-1.45c0-.39-.2-.5-.5-.5a.84.84,0,0,0-.64.34v1.61h-.34v-3h.34v1.16a1,1,0,0,1,.78-.38.62.62,0,0,1,.7.7v1.56Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104,392.68v-1.5c0-.27-.12-.45-.4-.45a.74.74,0,0,0-.58.34v1.61h-.35v-1.5c0-.27-.11-.45-.4-.45a.77.77,0,0,0-.58.34v1.61h-.34v-2.2h.34v.32a1,1,0,0,1,.72-.38.56.56,0,0,1,.58.41.94.94,0,0,1,.74-.41c.4,0,.61.23.61.67v1.59Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.41,392.68v-.25a.94.94,0,0,1-.73.3.73.73,0,0,1-.76-.73.71.71,0,0,1,.76-.72,1,1,0,0,1,.73.29v-.39c0-.29-.24-.46-.56-.46a.87.87,0,0,0-.67.3l-.16-.23a1.15,1.15,0,0,1,.88-.37c.47,0,.85.21.85.75v1.51Zm0-.47v-.42a.77.77,0,0,0-.6-.27.5.5,0,0,0-.55.48.49.49,0,0,0,.55.48A.74.74,0,0,0,106.41,392.21Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.92,392.68v-1.44c0-.39-.2-.51-.49-.51a.84.84,0,0,0-.65.34v1.61h-.35v-2.2h.35v.32a1,1,0,0,1,.78-.38.63.63,0,0,1,.7.71v1.55Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.53,392.68v-.33a.92.92,0,0,1-.74.38c-.57,0-1-.44-1-1.15s.4-1.16,1-1.16a.91.91,0,0,1,.74.39v-1.17h.35v3Zm0-.6v-1a.79.79,0,0,0-.65-.35c-.45,0-.71.36-.71.85s.26.85.71.85A.79.79,0,0,0,111.53,392.08Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114,392.68v-.31a1.09,1.09,0,0,1-.78.36.62.62,0,0,1-.7-.7v-1.55h.34v1.45c0,.38.19.5.49.5a.84.84,0,0,0,.65-.34v-1.61h.34v2.2Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.15,393.25l-.17-.14a.66.66,0,0,0,.3-.42h-.07a.22.22,0,0,1-.22-.23.25.25,0,0,1,.24-.25c.16,0,.29.13.29.35A.87.87,0,0,1,115.15,393.25Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.44,392.68l-1.76-2.42v2.42h-.38v-3h.38l1.75,2.37v-2.37h.38v3Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.38,391.57a1.1,1.1,0,0,1,1.08-1.15,1.07,1.07,0,0,1,1.05,1.18v.09h-1.77a.77.77,0,0,0,.79.76,1,1,0,0,0,.68-.28l.16.22a1.2,1.2,0,0,1-.87.34A1.09,1.09,0,0,1,120.38,391.57Zm1.07-.86a.73.73,0,0,0-.72.72h1.45A.72.72,0,0,0,121.45,390.71Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.4,392.34v1.17h-.34v-3h.34v.33a.9.9,0,0,1,.74-.39c.58,0,1,.44,1,1.15s-.4,1.16-1,1.16A.92.92,0,0,1,123.4,392.34Zm1.36-.77c0-.48-.26-.84-.7-.84a.82.82,0,0,0-.66.35v1a.83.83,0,0,0,.66.36C124.5,392.43,124.76,392.06,124.76,391.57Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127,392.68v-.25a.92.92,0,0,1-.72.3.73.73,0,0,1-.77-.73.72.72,0,0,1,.77-.72.93.93,0,0,1,.72.29v-.39c0-.29-.23-.46-.55-.46a.86.86,0,0,0-.67.3l-.16-.23a1.13,1.13,0,0,1,.88-.37c.46,0,.85.21.85.75v1.51Zm0-.47v-.42a.76.76,0,0,0-.6-.27.5.5,0,0,0-.54.48.49.49,0,0,0,.54.48A.73.73,0,0,0,127,392.21Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.06,392.68v-3h.34v3Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.86,398.13v-2.7h-1v-.33h2.3v.33h-1v2.7Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.39,396.15a.26.26,0,0,1,.25-.25.25.25,0,0,1,0,.5A.26.26,0,0,1,31.39,396.15Zm0,1.78a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25.25.25,0,0,1-.25.25A.26.26,0,0,1,31.39,397.93Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.59,396.72v1h-.26v-1h-.88v-.24h.88v-.94h.26v.94h.87v.24Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,397.82l.19-.29a.77.77,0,0,0,.65.31c.62,0,.86-.61.86-1.19a.53.53,0,0,0,0-.12,1.09,1.09,0,0,1-.85.48.93.93,0,0,1-1-1,1,1,0,0,1,1.07-1c.84,0,1.17.74,1.17,1.57s-.39,1.56-1.24,1.56A1.08,1.08,0,0,1,36,397.82Zm1.68-1.59c0-.38-.23-.85-.76-.85a.66.66,0,0,0-.7.64.63.63,0,0,0,.7.66A.94.94,0,0,0,37.65,396.23Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.83,398.13l1.22-2.7H38.42v-.33h2.07v.26l-1.25,2.77Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.17,398.13l1.22-2.7H40.76v-.33h2.07v.26l-1.24,2.77Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.09,397.18v-.3h1.1v.3Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.13,398.13v-2.54l-.49.52-.22-.23.76-.78h.33v3Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46,397.18v-.3h1.09v.3Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.53,397.7l.23-.26a1,1,0,0,0,.83.41.66.66,0,0,0,.71-.65.65.65,0,0,0-.7-.66,1,1,0,0,0-.7.28l-.28-.09V395.1h1.86v.33H48v1.06a1,1,0,0,1,.71-.27.93.93,0,0,1,1,1,1,1,0,0,1-1.09,1A1.23,1.23,0,0,1,47.53,397.7Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,397.68l.22-.23a1.08,1.08,0,0,0,.85.4c.44,0,.71-.22.71-.57s-.31-.54-.76-.54h-.31v-.35h.31c.39,0,.71-.15.71-.5s-.31-.52-.68-.52a1,1,0,0,0-.8.37l-.21-.24a1.3,1.3,0,0,1,1-.47c.58,0,1,.3,1,.81a.72.72,0,0,1-.66.7.78.78,0,0,1,.71.75c0,.51-.41.88-1.08.88A1.27,1.27,0,0,1,50,397.68Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.57,397.68l.22-.23a1.08,1.08,0,0,0,.85.4c.44,0,.71-.22.71-.57s-.31-.54-.76-.54h-.31v-.35h.31c.39,0,.71-.15.71-.5s-.31-.52-.68-.52a1,1,0,0,0-.8.37l-.21-.24a1.3,1.3,0,0,1,1-.47c.59,0,1,.3,1,.81a.72.72,0,0,1-.65.7.78.78,0,0,1,.7.75c0,.51-.41.88-1.08.88A1.28,1.28,0,0,1,52.57,397.68Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.1,397.68l.23-.23a1,1,0,0,0,.84.4c.44,0,.71-.22.71-.57s-.31-.54-.75-.54h-.32v-.35h.32c.38,0,.7-.15.7-.5s-.31-.52-.68-.52a1,1,0,0,0-.8.37l-.21-.24a1.31,1.31,0,0,1,1-.47c.58,0,1,.3,1,.81a.72.72,0,0,1-.65.7.78.78,0,0,1,.7.75c0,.51-.41.88-1.08.88A1.28,1.28,0,0,1,55.1,397.68Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.74,396.62c0-.75.32-1.57,1.15-1.57s1.16.82,1.16,1.57-.33,1.57-1.16,1.57S57.74,397.35,57.74,396.62Zm1.93,0c0-.61-.2-1.23-.78-1.23s-.77.62-.77,1.23.2,1.23.77,1.23S59.67,397.22,59.67,396.62Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.52,397.36a.9.9,0,0,1,.72-.79.81.81,0,0,1-.67-.73c0-.55.53-.79,1-.79s1,.24,1,.79a.82.82,0,0,1-.68.73.9.9,0,0,1,.73.79c0,.52-.5.83-1.09.83S60.52,397.88,60.52,397.36Zm1.79,0c0-.39-.52-.56-.7-.59s-.71.2-.71.59.33.53.71.53S62.31,397.65,62.31,397.32Zm0-1.43c0-.32-.3-.5-.66-.5s-.66.18-.66.5.48.49.66.52S62.27,396.26,62.27,395.89Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.17,397.36a.89.89,0,0,1,.72-.79.81.81,0,0,1-.67-.73c0-.55.53-.79,1-.79s1,.24,1,.79a.82.82,0,0,1-.68.73.9.9,0,0,1,.72.79c0,.52-.49.83-1.09.83S63.17,397.88,63.17,397.36Zm1.79,0c0-.39-.52-.56-.71-.59s-.7.2-.7.59.33.53.7.53S65,397.65,65,397.32Zm0-1.43c0-.32-.29-.5-.66-.5s-.65.18-.65.5.47.49.65.52S64.91,396.26,64.91,395.89Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.58,398.22,66.65,395h.27l-1.08,3.21Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.73,398.13v-2.54l-.49.52-.22-.23.76-.78h.33v3Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.69,396.62c0-.75.33-1.57,1.16-1.57s1.16.82,1.16,1.57-.33,1.57-1.16,1.57S68.69,397.35,68.69,396.62Zm1.94,0c0-.61-.2-1.23-.78-1.23s-.77.62-.77,1.23.2,1.23.77,1.23S70.63,397.22,70.63,396.62Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.79,398.13l1.23-2.7H71.39v-.33h2.06v.26l-1.24,2.77Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.11,403.58v-3h2v.34H29.49v1h1.58v.33H29.49v1.05H31.1v.33Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.62,401.61a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25.26.26,0,0,1-.25.25A.25.25,0,0,1,31.62,401.61Zm0,1.77a.25.25,0,0,1,.25-.25.25.25,0,0,1,0,.5A.25.25,0,0,1,31.62,403.38Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.83,400.85a.23.23,0,0,1,.46,0,.23.23,0,0,1-.46,0Zm.06,2.73v-2.19h.34v2.19Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.39,403.58v-1.43c0-.39-.2-.51-.49-.51a.84.84,0,0,0-.65.34v1.6h-.34v-2.19h.34v.32a1.05,1.05,0,0,1,.79-.38.62.62,0,0,1,.69.71v1.54Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.51,403.58v-1.89h-.36v-.3h.36v-.17a.63.63,0,0,1,.64-.71.63.63,0,0,1,.46.16l-.14.22a.41.41,0,0,0-.27-.1c-.22,0-.35.15-.35.43v.17h.45v.3h-.45v1.89Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.58,402.48a1.09,1.09,0,1,1,1.09,1.16A1.08,1.08,0,0,1,38.58,402.48Zm1.81,0a.73.73,0,1,0-1.45,0,.73.73,0,1,0,1.45,0Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.13,402.48a1.84,1.84,0,0,1,1.8-1.8,1.4,1.4,0,0,1,1.43,1.45c0,.7-.4,1.07-.78,1.07a.4.4,0,0,1-.42-.37v0a.91.91,0,0,1-.72.4.68.68,0,0,1-.7-.74,1.14,1.14,0,0,1,1.07-1.14.6.6,0,0,1,.58.35l.06-.28h.31l-.26,1.23s0,.07,0,.1a.21.21,0,0,0,.22.23c.18,0,.49-.2.49-.82a1.23,1.23,0,0,0-1.28-1.29,1.68,1.68,0,0,0-1.64,1.63,1.26,1.26,0,0,0,1.31,1.28,1.57,1.57,0,0,0,.84-.25l.08.12a1.75,1.75,0,0,1-.94.28A1.4,1.4,0,0,1,41.13,402.48Zm2.08,0,.13-.63a.5.5,0,0,0-.47-.33.86.86,0,0,0-.8.87.45.45,0,0,0,.47.5A.84.84,0,0,0,43.21,402.53Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.36,403.58l-.78-1-.37.36v.62h-.34v-3h.34v2l1.15-1.17h.43l-1,1,1,1.2Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.58,403.58v-.25a1,1,0,0,1-.73.31.73.73,0,0,1-.77-.73.72.72,0,0,1,.77-.72.94.94,0,0,1,.73.29v-.39c0-.29-.24-.46-.56-.46a.86.86,0,0,0-.67.3l-.16-.23a1.15,1.15,0,0,1,.88-.37c.47,0,.85.21.85.74v1.51Zm0-.46v-.42a.76.76,0,0,0-.6-.27.48.48,0,1,0,0,1A.76.76,0,0,0,48.58,403.12Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.09,403.58v-1.43c0-.39-.2-.51-.5-.51a.87.87,0,0,0-.65.34v1.6H49.6v-2.19h.34v.32a1.09,1.09,0,0,1,.79-.38.63.63,0,0,1,.7.71v1.54Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.11,404.14l.17-.24a.85.85,0,0,0,.71.29c.37,0,.71-.17.71-.64v-.33a.93.93,0,0,1-.74.39,1,1,0,0,1-1-1.13c0-.71.4-1.15,1-1.15a.91.91,0,0,1,.74.39v-.33H54v2.16c0,.7-.51.93-1,.93A1.12,1.12,0,0,1,52.11,404.14ZM53.7,403v-1a.81.81,0,0,0-.65-.35c-.45,0-.71.35-.71.84s.26.83.71.83A.81.81,0,0,0,53.7,403Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.1,403.58v-.25a1,1,0,0,1-.73.31.73.73,0,0,1-.76-.73.71.71,0,0,1,.76-.72.94.94,0,0,1,.73.29v-.39c0-.29-.24-.46-.56-.46a.87.87,0,0,0-.67.3l-.16-.23a1.15,1.15,0,0,1,.88-.37c.47,0,.85.21.85.74v1.51Zm0-.46v-.42a.73.73,0,0,0-.6-.27.48.48,0,1,0,0,1A.73.73,0,0,0,56.1,403.12Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.13,403.58v-2.19h.34v.35a.92.92,0,0,1,.73-.4v.35h-.13a.79.79,0,0,0-.6.35v1.55Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.5,402.48a1.09,1.09,0,1,1,1.08,1.16A1.08,1.08,0,0,1,58.5,402.48Zm1.81,0a.73.73,0,1,0-.73.85A.76.76,0,0,0,60.31,402.48Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.1,402.48a1.09,1.09,0,1,1,1.08,1.16A1.08,1.08,0,0,1,61.1,402.48Zm1.81,0a.73.73,0,1,0-.73.85A.76.76,0,0,0,62.91,402.48Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.7,402.48a1.1,1.1,0,0,1,1.08-1.15,1.07,1.07,0,0,1,1.06,1.18v.09H64.06a.78.78,0,0,0,.79.76,1,1,0,0,0,.68-.28l.16.22a1.18,1.18,0,0,1-.87.34A1.09,1.09,0,0,1,63.7,402.48Zm1.08-.86a.73.73,0,0,0-.72.72H65.5A.71.71,0,0,0,64.78,401.62Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68,403.58v-.32a1,1,0,0,1-.74.38c-.58,0-1-.44-1-1.15s.4-1.16,1-1.16a.93.93,0,0,1,.74.39v-1.17h.34v3Zm0-.6v-1a.82.82,0,0,0-.66-.35c-.44,0-.71.36-.71.85s.27.84.71.84A.8.8,0,0,0,68,403Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.48,403.58v-.3a1.07,1.07,0,0,1-.78.36.62.62,0,0,1-.7-.7v-1.55h.34v1.44c0,.39.19.5.5.5a.83.83,0,0,0,.64-.33v-1.61h.34v2.19Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.43,403.38a.25.25,0,0,1,.25-.25.25.25,0,0,1,0,.5A.25.25,0,0,1,71.43,403.38Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.39,402.48a1.09,1.09,0,0,1,1.1-1.15.92.92,0,0,1,.8.39l-.22.2a.65.65,0,0,0-.56-.28.85.85,0,0,0,0,1.69.67.67,0,0,0,.56-.28l.22.21a.92.92,0,0,1-.8.38A1.09,1.09,0,0,1,72.39,402.48Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.65,402.48a1.09,1.09,0,1,1,1.08,1.16A1.08,1.08,0,0,1,74.65,402.48Zm1.81,0a.73.73,0,1,0-.73.85A.76.76,0,0,0,76.46,402.48Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80,403.58v-1.49c0-.27-.12-.45-.41-.45A.74.74,0,0,0,79,402v1.6H78.7v-1.49c0-.27-.11-.45-.41-.45a.74.74,0,0,0-.57.34v1.6h-.34v-2.19h.34v.32a.94.94,0,0,1,.71-.38.58.58,0,0,1,.59.41.92.92,0,0,1,.73-.41c.4,0,.62.23.62.67v1.58Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,409l-.57-1.77L29.85,409h-.34l-.7-2.2h.36l.53,1.75.58-1.75h.3l.57,1.75.54-1.75h.36l-.7,2.2Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.34,409l-.58-1.77L33.19,409h-.34l-.7-2.2h.35l.54,1.75.58-1.75h.29l.58,1.75.53-1.75h.36l-.7,2.2Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.67,409l-.57-1.77L36.53,409h-.34l-.7-2.2h.35l.54,1.75.57-1.75h.3l.57,1.75.54-1.75h.36L38,409Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.84,408.83a.25.25,0,0,1,.5,0,.25.25,0,0,1-.5,0Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.45,409l-.78-1-.37.36V409H40v-3h.34v2l1.15-1.17h.44l-1,1,1,1.2Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.67,409v-.25a.94.94,0,0,1-.73.3.72.72,0,0,1-.76-.72.71.71,0,0,1,.76-.73.94.94,0,0,1,.73.3v-.4c0-.29-.24-.46-.56-.46a.88.88,0,0,0-.67.31l-.16-.24a1.18,1.18,0,0,1,.88-.36c.47,0,.85.21.85.74V409Zm0-.46v-.42a.74.74,0,0,0-.6-.27.48.48,0,1,0,0,1A.74.74,0,0,0,43.67,408.58Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.18,409V407.6c0-.39-.2-.51-.49-.51a.87.87,0,0,0-.65.34V409h-.35v-2.2H45v.32a1.08,1.08,0,0,1,.78-.37.62.62,0,0,1,.7.71V409Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.2,409.6l.17-.25a.84.84,0,0,0,.72.3.63.63,0,0,0,.71-.64v-.33a1,1,0,0,1-.75.39c-.57,0-1-.43-1-1.14s.4-1.14,1-1.14a.91.91,0,0,1,.75.39v-.34h.34V409c0,.69-.52.92-1,.92A1.12,1.12,0,0,1,47.2,409.6Zm1.6-1.19v-1a.87.87,0,0,0-.66-.35c-.45,0-.71.35-.71.84s.26.83.71.83A.84.84,0,0,0,48.8,408.41Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.19,409v-.25a.94.94,0,0,1-.73.3.72.72,0,0,1-.76-.72.71.71,0,0,1,.76-.73.94.94,0,0,1,.73.3v-.4c0-.29-.24-.46-.55-.46a.89.89,0,0,0-.68.31l-.16-.24a1.18,1.18,0,0,1,.88-.36c.47,0,.85.21.85.74V409Zm0-.46v-.42a.73.73,0,0,0-.6-.27.48.48,0,1,0,0,1A.73.73,0,0,0,51.19,408.58Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.22,409v-2.2h.34v.35a1,1,0,0,1,.73-.4v.35h-.13a.81.81,0,0,0-.6.35V409Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.59,407.94a1.09,1.09,0,1,1,1.09,1.15A1.08,1.08,0,0,1,53.59,407.94Zm1.81,0a.73.73,0,1,0-.72.85A.76.76,0,0,0,55.4,407.94Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.19,407.94a1.09,1.09,0,1,1,1.09,1.15A1.08,1.08,0,0,1,56.19,407.94Zm1.81,0a.73.73,0,1,0-.72.85A.76.76,0,0,0,58,407.94Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.79,407.94a1.09,1.09,0,0,1,1.08-1.15A1.07,1.07,0,0,1,60.93,408v.08H59.15a.77.77,0,0,0,.79.76.94.94,0,0,0,.68-.28l.17.22a1.22,1.22,0,0,1-.88.34A1.08,1.08,0,0,1,58.79,407.94Zm1.08-.87a.74.74,0,0,0-.72.73h1.44A.71.71,0,0,0,59.87,407.07Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.07,409v-.33a.91.91,0,0,1-.74.38c-.58,0-1-.43-1-1.15a1,1,0,0,1,1-1.15.91.91,0,0,1,.74.39V406h.34v3Zm0-.6v-1a.83.83,0,0,0-.66-.36.75.75,0,0,0-.71.85c0,.49.27.85.71.85A.82.82,0,0,0,63.07,408.44Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.57,409v-.31a1.07,1.07,0,0,1-.78.36.62.62,0,0,1-.7-.7v-1.55h.34v1.45c0,.39.2.5.5.5a.84.84,0,0,0,.64-.33v-1.62h.34V409Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.53,408.83a.25.25,0,0,1,.25-.25.26.26,0,0,1,.25.25.25.25,0,0,1-.25.25A.25.25,0,0,1,66.53,408.83Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.49,407.94a1.08,1.08,0,0,1,1.09-1.15,1,1,0,0,1,.81.38l-.23.21a.66.66,0,0,0-.56-.29.86.86,0,0,0,0,1.7.66.66,0,0,0,.56-.29l.23.21a1,1,0,0,1-.81.38A1.08,1.08,0,0,1,67.49,407.94Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.74,407.94a1.09,1.09,0,1,1,1.09,1.15A1.08,1.08,0,0,1,69.74,407.94Zm1.81,0a.73.73,0,1,0-.72.85A.76.76,0,0,0,71.55,407.94Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.12,409v-1.49c0-.28-.12-.46-.41-.46a.75.75,0,0,0-.58.34V409h-.34v-1.49c0-.28-.11-.46-.4-.46a.78.78,0,0,0-.58.34V409h-.34v-2.2h.34v.32a.94.94,0,0,1,.71-.37.57.57,0,0,1,.59.41.92.92,0,0,1,.73-.41c.4,0,.62.22.62.66V409Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0.13,
    y: 0.13,
    width: 300.64,
    height: 425.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial3);
export default __webpack_public_path__ + "static/media/guideMaterial3.1d1b98a0ffc232a24b225fe576ea517d.svg";
export { ForwardRef as ReactComponent };